/**
 * Centralized Blog Asset Paths
 * Use these constants instead of hardcoding relative paths
 */

export const BLOG_ASSETS = {
  // Author images
  AUTHOR: {
    ASHISH_DHANDAR: 'assets/images/blog/author/ashish-dhandar.png',
    VARROC_CONNECT: 'assets/images/websitev2/varroc-connect-logo.png',
    DIXIT_ROY_MAHIDHARA: 'assets/images/blog/author/dixit-mahidhara.jpeg',
    SIJI_SUNNY: 'assets/images/blog/author/siji-sunny.jpeg',
    AJAZ_BEIG: 'assets/images/blog/author/ajaz-beig.png',
    DIVYANK_VIJAYVERGIYA: 'assets/images/blog/author/divyank-vijayvergiya.jpeg',
    RAJASHRI_THORAT: 'assets/images/blog/author/rajashri-thorat.jpeg',
    SWATI_VENATTU: 'assets/images/blog/author/swati-venattu.jpeg',
    TEAM_VARROC_CONNECT: 'assets/images/blog/author/varroc-connect-logo-only.png',
  },

  // Blog banners/cover images
  BANNER: {
    VEHICLE_MONITORING: 'assets/images/blog/blog-banner/Vehicle-Monitoring-Systems.jpeg',
    NO_NEGLIGENCE_NOVEMBER: 'assets/images/blog/blog-banner/no-negligence-november.jpg',
    VEHICLE_HEALTH_MONITORING: 'assets/images/blog/blog-banner/Vehicle-Health-Monitoring.png',
    GPS_TRACKER_VS_TELEMATICS: 'assets/images/blog/blog-banner/gps-tracker-vs-telematics.png',
    GEOFENCING_FLEET_SECURITY: 'assets/images/blog/blog-banner/geofencing-fleet-security.png',
    GPS_VS_TELEMATICS: 'assets/images/blog/blog-banner/gps-vs-telematic.png',
    DEVICELESS_TELEMATICS: 'assets/images/blog/blog-banner/deviceless-telematics-by-varroc-connect.png',
    GPS_TRACKING_VS_FLEET_MANAGEMENT_SOFTWARE: 'assets/images/blog/blog-banner/gps-tracking-vs-fleet-fleet-management-software.png',
    VEHICLE_INTELLIGENCE_LAYER: 'assets/images/blog/blog-banner/vehicle-intelligence-layer.png'
  },

  // Blog content images (organize by blog slug)
  CONTENT: {
    // Example: 'smart-plug-device-for-vehicle-health-monitoring' folder
    // SMART_PLUG: 'assets/images/blog/content/smart-plug-device/'
  }
};

/**
 * Helper function to get author image with extension
 * @param authorPath - Base author path from BLOG_ASSETS.AUTHOR
 * @param extension - File extension (jpg, png, etc.) - default: jpg
 * @returns Full image path
 */
export function getAuthorImage(authorPath: string, extension: string = 'jpg'): string {
  return `${authorPath}.${extension}`;
}

/**
 * Helper function to get author icon (circular)
 * @param authorPath - Base author path from BLOG_ASSETS.AUTHOR
 * @returns Full image path
 */
export function getAuthorIcon(authorPath: string): string {
  return `${authorPath}`;
}

/**
 * Helper function to get blog content image
 * @param blogSlug - Blog slug (folder name)
 * @param imageName - Image name without extension
 * @param extension - File extension - default: jpg
 * @returns Full image path
 */
export function getBlogContentImage(blogSlug: string, imageName: string, extension: string = 'jpg'): string {
  return `assets/images/blog/content/${blogSlug}/${imageName}.${extension}`;
}
